import type { AnalyticsSender, Offer } from '@funtech-int/yango-shared';

import {
    headerSubscriptionOfferNavigated,
    headerSubscriptionOfferShowed,
    headerSubscriptionOfferSucceed,
} from '@kinopoisk-int/evgen-web-events/web/header';
import { HeaderOfferEntityTypes } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import {
    OfferPlacementAnalytics,
    TARIFFICATOR_BILLING_PRODUCT_ID,
} from '@/shared/lib/analytics/offer';
import { getOfferTitle } from '@/shared/lib/analytics';

interface HeaderOfferData {
    offer: Offer | null | undefined;
    buttonText: string;
}

type HeaderOfferAnalytics = OfferPlacementAnalytics<HeaderOfferData>;

export function createHeaderOfferAnalytics(eventSender: AnalyticsSender): HeaderOfferAnalytics {
    let data: HeaderOfferData | undefined;

    const getEventOfferMeta = (offer: Offer | null | undefined, buttonText: string) => {
        const tariffName = offer?.catalogCompositeOffer?.tariffOffer?.name;
        const optionName = offer?.catalogCompositeOffer?.optionOffers?.[0]?.name;

        return {
            entityType: HeaderOfferEntityTypes.SubscriptionOption,
            offerTitle: getOfferTitle(offer),
            buttonText,
            billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
            billingProductIds: offer?.billingProductIds || 'NONE',
            offerTariffName: tariffName || 'NONE',
            offerOptionNames: optionName || 'NONE',
        };
    };

    return {
        setData(value) {
            data = value;
        },
        showed() {
            if (!data) return;

            const { offer, buttonText } = data;

            eventSender.sendOnce(headerSubscriptionOfferShowed, {
                ...getEventOfferMeta(offer, buttonText),
                show: offer?.offerPositionsData ?? {},
            });
        },
        navigated() {
            if (!data) return;

            const { offer, buttonText } = data;

            eventSender.send(headerSubscriptionOfferNavigated, {
                ...getEventOfferMeta(offer, buttonText),
                click: offer?.offerPositionsData ?? {},
            });
        },
        succeeded() {
            if (!data) return;

            const { offer, buttonText } = data;

            eventSender.send(headerSubscriptionOfferSucceed, {
                ...getEventOfferMeta(offer, buttonText),
            });
        },
    };
}
